// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__dMbAG {
  cursor: pointer;
  display: flex;
  justify-content: end;
  gap: 24px;
  width: 100%;
}

.styles_icon__quSBv {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/CardNavNew/cardToolbar/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".wrapper {\n  cursor: pointer;\n  display: flex;\n  justify-content: end;\n  gap: 24px;\n  width: 100%;\n}\n\n.icon {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__dMbAG`,
	"icon": `styles_icon__quSBv`
};
export default ___CSS_LOADER_EXPORT___;
